import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Field } from 'formik';
import {
	Box,
	HStack,
	VStack,
	Text,
	Button,
	Checkbox,
	CheckboxGroup,
	Center,
	Spinner,
	SimpleGrid,
	Divider
} from '@chakra-ui/react';
import { InputText, Form } from '../components/form';
import { toast } from "react-toastify";
import { fetchWrapper } from '../helpers';

// Which delivery-status events the webhook should be triggered for — user
// picks any combination, sent to the backend as webhook_events: [values].
const WEBHOOK_EVENT_OPTIONS = [
	{ label: 'Message Sent', value: 'sent' },
	{ label: 'Message Delivered', value: 'delivered' },
	{ label: 'Message Read', value: 'read' },
	{ label: 'Message Clicked', value: 'clicked' },
	{ label: 'Message Failed', value: 'failed' },
];

function Create({ meClose, loadList, customer, setOpenWebhook }) {
	const customer_id = customer?.customer_id


	const [formData, setFormData] = useState({
		webhook_url: '',
		customer_id: customer_id,
		method: 'Post',
		webhook_events: []
	});
	const [loadingDetail, setLoadingDetail] = useState(true);
	const [saving, setSaving] = useState(false);

	const FormSchema = Yup.object().shape({
		webhook_url: Yup.string().required('Required'),

	});

	useEffect(() => {
		loadDetail();


	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [customer_id])
	const loadDetail = async () => {
		setLoadingDetail(true);
		try {
			const url = `${process.env.REACT_APP_API_URL}/customer/by-id?id=${customer_id}`;
			const data = await fetchWrapper.get(url)
			const customer = data?.data
			setFormData({
				webhook_url: customer.webhook_url || '',
				customer_id: customer.id,
				method: 'Post',
				webhook_events: customer.webhook_events || []
			});
		} finally {
			setLoadingDetail(false);
		}
	}








	const onSubmit = async (values) => {
		setSaving(true);
		try {
			let data = values;
			const url = `${process.env.REACT_APP_API_URL}/customer-portal/update`;
			await fetchWrapper.post(url, data)
			loadList()
			meClose();
			setOpenWebhook(false);
			toast(`Record has been saved `, {
				type: "info"
			});
		} finally {
			setSaving(false);
		}
	}

	if (loadingDetail) {
		return (
			<Center py="40px">
				<Spinner size="lg" color="blue.500" thickness="3px" />
			</Center>
		);
	}

	return (


			<Form
				enableReinitialize
				validationSchema={FormSchema}
				initialValues={formData}
				onSubmit={onSubmit}
			>
				<Box
					mb="20px" p="14px" borderRadius="10px"
					bg="rgb(var(--brand-primary-rgb) / 0.06)"
					border="1px solid" borderColor="rgb(var(--brand-primary-rgb) / 0.15)"
				>
					<Text fontSize="12.5px" lineHeight="1.6" color="gray.700" fontFamily="'Inter', sans-serif">
						Keep track of your message deliveries in real-time with our Webhook, automatically posting status updates directly to your system. Stay informed about delivery confirmations and failures instantly.
					</Text>
				</Box>

				<VStack align="stretch" spacing="14px" mb="18px">
					<Box className="webhook-modern-field">
						<InputText name="webhook_url" title="URL" placeholder="Enter your URL" />
					</Box>

					<Box className="webhook-modern-field disabled">
						<InputText name="method" title="Method" inputProps={{ disabled: true }} />
					</Box>
				</VStack>

				<Box mb="6px">
					<Text fontSize="12px" fontWeight="700" color="gray.700" mb="10px">Trigger Events</Text>
					<Field name="webhook_events">
						{({ field, form }) => (
							<CheckboxGroup
								colorScheme="blue"
								value={field.value || []}
								onChange={(vals) => form.setFieldValue('webhook_events', vals)}
							>
								<SimpleGrid columns={2} spacing={2}>
									{WEBHOOK_EVENT_OPTIONS.map(opt => (
										<Checkbox
											key={opt.value} value={opt.value}
											p="9px 12px" borderRadius="8px" border="1px solid" borderColor="gray.200"
											bg="gray.50" fontSize="13px"
											_hover={{ borderColor: 'rgb(var(--brand-primary-rgb) / 0.4)' }}
										>
											{opt.label}
										</Checkbox>
									))}
								</SimpleGrid>
							</CheckboxGroup>
						)}
					</Field>
				</Box>

				<Divider my="18px" borderColor="gray.100" />

				<HStack justify="flex-end" spacing={3}>
					<Button
						variant="ghost" color="gray.600" fontSize="14px" fontWeight="500"
						fontFamily="'Lato', sans-serif" borderRadius="8px"
						onClick={() => setOpenWebhook(false)}
					>
						Close
					</Button>
					<Button
						color="#fff" bg="var(--brand-primary)" _hover={{ bg: 'var(--brand-primary-hover)' }}
						borderRadius="8px" py="10px" px="22px" fontSize="14px" fontWeight="500"
						fontFamily="'Lato', sans-serif"
						type='submit'
						isLoading={saving}
						loadingText={formData.webhook_url === "" ? 'Adding…' : 'Updating…'}
					>
						{formData.webhook_url === "" ? 'Add' : 'Update'} Web Hook
					</Button>
				</HStack>
			</Form>

		
	)
}

export default Create;